import React from 'react';
import Select, { components } from 'react-select';
import { withStyles } from '@material-ui/core';
import Search from '@/assets/icons/Search';

import defaultStyles from './style';
import InputLabel from '../atomic/InputLabel';
import CustomOption from './Option';

const Control = ({ children, ...props }) => (
  <components.Control {...props}>
    <Search className="m-2 mr-0" />
    {children}
  </components.Control>
);

const Autocomplete = ({
  label,
  theme,
  options,
  disabled,
  onChange,
  className,
  toShrink = true,
  styles = {},
  isClearable = true,
  placeholder = 'Velg',
  maxMenuHeight,
  otherComponents,
  ...props
}) => {
  return (
    <div className={className}>
      {label && <InputLabel shrink={toShrink}>{label}</InputLabel>}

      <Select
        styles={{
          ...defaultStyles(theme),
          ...styles,
        }}
        options={options}
        onChange={onChange}
        isDisabled={disabled}
        placeholder={placeholder}
        isClearable={isClearable}
        maxMenuHeight={maxMenuHeight}
        components={{
          Control,
          Option: CustomOption,
          ...otherComponents,
        }}
        {...props}
      />
    </div>
  );
};

export default withStyles({}, { withTheme: true })(Autocomplete);
